import { ReactComponent as LogoMobileIcon } from "./logo-mobile.svg";
import { ReactComponent as LogoIcon } from "./logo.svg";

import { ReactComponent as Line1Icon } from "./mobile-line-1-banner.svg";
import { ReactComponent as Line1DesktopIcon } from "./desctop-line-1-banner.svg";
import { ReactComponent as Line2DesktopIcon } from "./desctop-line-2-banner.svg";
import { ReactComponent as Line3DesktopIcon } from "./desctop-line-3-banner.svg";
import { ReactComponent as Line2Icon } from "./mobile-line-2-banner.svg";
import { ReactComponent as Line3Icon } from "./mobile-line-3-banner.svg";
import { ReactComponent as PlayVideoIcon } from "./play-video.svg";
import { ReactComponent as ArrowDownIcon } from "./arrow-down.svg";
import { ReactComponent as VenueManagement1Icon } from "./venue-managment1.svg";
import { ReactComponent as VenueManagement2Icon } from "./venue-managment2.svg";
import { ReactComponent as VenueManagement3Icon } from "./venue-managment3.svg";
import { ReactComponent as VenueManagement4Icon } from "./venue-managment4.svg";
import { ReactComponent as VenueManagement5Icon } from "./venue-managment5.svg";
import { ReactComponent as VenueManagement6Icon } from "./venue-managment6.svg";
import { ReactComponent as VenueManagement7Icon } from "./venue-managment7.svg";
import { ReactComponent as VenueManagement8Icon } from "./venue-managment8.svg";
import { ReactComponent as VenueManagement9Icon } from "./venue-managment9.svg";
import { ReactComponent as VenueManagement10Icon } from "./venue-managment10.svg";
import { ReactComponent as VenueManagement11Icon } from "./venue-managment11.svg";
import { ReactComponent as VenueManagement12Icon } from "./venue-managment12.svg";

import { ReactComponent as Benefits1Icon } from "../../assets/icons/benefits1.svg";
import { ReactComponent as Benefits2Icon } from "../../assets/icons/benefits2.svg";
import { ReactComponent as Benefits3Icon } from "../../assets/icons/benefits3.svg";
import { ReactComponent as Benefits4Icon } from "../../assets/icons/benefits4.svg";

import { ReactComponent as ChampionIcon } from "./champion.svg";

import { ReactComponent as InCallIcon } from "./incall.svg";
import { ReactComponent as OutCallIcon } from "./outcall.svg";
import { ReactComponent as LocationsIcon } from "./location.svg";
import { ReactComponent as PhoneIcon } from "./phone.svg";
import { ReactComponent as EmailIcon } from "./email.svg";
import { ReactComponent as CloseIcon } from "./close.svg";
import { ReactComponent as UploadIcon } from "./upload.svg";
import { ReactComponent as PlusIcon } from "./plus.svg";
import { ReactComponent as TriangleIcon } from "./triangle.svg";

import React from "react";

const LogoLoader = ({ w, h, color } = {}) => (
    <svg
        viewBox='0 0 13 16'
        width={w || '50px'}
        height={h || 'auto'}
        xmlns='http://www.w3.org/2000/svg'
    >
        <defs>
            <linearGradient x1='-3.46552756%' y1='83.6438593%' x2='106.318728%' y2='13.4998541%' id='linearGradientLogo-1'>
                <stop stopColor='#04E762' offset='0%'/>
                <stop stopColor='#21F596' offset='100%'></stop>
            </linearGradient>
            <linearGradient x1='-3.46552756%' y1='83.6438583%' x2='106.318728%' y2='13.4998552%' id='linearGradientLogo-2'>
                <stop stopColor='#FAAC18' offset='0%'></stop>
                <stop stopColor='#F8EE45' offset='100%'></stop>
            </linearGradient>
        </defs>
        <g id='Freebie' stroke='none' strokeWidth='1' fillRule='evenodd'>
            <g id='Business-Card-Copy-56' transform='translate(-121.000000, -405.000000)'>
                <g id='Group-2' transform='translate(119.000000, 405.000000)'>
                    <rect id='Rectangle' fillOpacity='0' x='0' y='0' width='16' height='16'></rect>
                    <g id='Group' transform='translate(2.000000, 0.000000)' fillRule='nonzero'>
                        <path d='M11.7838573,2.64631853 C12.4286446,1.76362446 12.1313253,0.745909292 11.3864457,0.275896805 C10.641566,-0.194115682 9.66400485,-0.106962448 8.98575899,0.875578019 L6.1788775,4.73358387 C5.75752283,5.31043902 4.95961576,5.31043902 4.53861666,4.73358387 L3.00502789,2.62792491 C2.04659315,1.42679048 0.675220652,2.02640455 0.343771191,2.51694469 C-0.176853341,3.28746107 -0.0267518494,3.97239712 0.497363581,4.73358387 L2.34330548,7.41357305 C2.89159992,8.16458053 2.89159992,9.23414981 2.34330548,9.98515729 L0.379206083,13.2506114 C-0.315927252,14.2869923 0.0716463059,15.0567105 0.531804692,15.4825008 C1.354263,16.2435316 2.18620816,16.0078976 2.90200052,15.4825008 L4.61328711,12.4187292 C4.99623983,11.8943154 5.72125433,11.8943154 6.10385149,12.4187292 L8.1345321,15.3427875 C8.69456045,16.1094491 9.85287532,16.2180441 10.5494439,15.6016623 C11.2460125,14.9856718 11.2169993,13.8775598 10.6569709,13.1108982 L8.48334976,10.1346544 C7.87105209,9.29637503 7.87105209,8.10235531 8.48334976,7.26407598 L11.7838573,2.64631853 Z' id='Fill-1-Copy' fill='#394d69'></path>
                        <path d='M1.1927323,12.5384994 L3.9219116,11.6625225 C4.80045859,11.3805378 5.72904512,11.9043359 5.99596771,12.8324582 C5.99685463,12.8355422 5.99773354,12.8386288 5.99860438,12.8417179 C6.26255689,13.7780145 5.76105123,14.7637101 4.87623322,15.0477076 L2.14705392,15.9236844 C1.26850693,16.2056691 0.339920395,15.6818711 0.072997819,14.7537487 C0.0721108816,14.7506647 0.0712319843,14.7475782 0.0703611318,14.7444891 C-0.193591377,13.8081925 0.307914283,12.8224969 1.1927323,12.5384994 Z' id='Rectangle-Copy' fill='url(#linearGradientLogo-1)'></path>
                        <path d='M1.74445644,7.02125799 L4.47363574,6.14528114 C5.35218272,5.86329645 6.28076926,6.38709449 6.54769184,7.31521683 C6.54857877,7.31830082 6.54945767,7.32138736 6.55032852,7.32447647 C6.81428103,8.26077307 6.31277537,9.24646864 5.42795735,9.53046615 L2.69877806,10.406443 C1.82023107,10.6884277 0.891644533,10.1646297 0.624721957,9.23650731 C0.62383502,9.23342332 0.622956122,9.23033678 0.62208527,9.22724767 C0.358132761,8.29095107 0.859638421,7.30525549 1.74445644,7.02125799 Z' id='Rectangle-Copy-10' fill='url(#linearGradientLogo-2)'></path>
                        <path d='M1.09565122,1.97620231 L4.01966988,1.16351688 C4.85682221,0.930843436 5.73038737,1.39383234 5.99650101,2.21123594 C6.25039067,2.99109199 5.8158288,3.82647881 5.0258799,4.07712464 C5.00845598,4.08265314 4.99093119,4.08786687 4.97331429,4.09276321 L2.04929563,4.90544863 C1.2121433,5.13812209 0.338578143,4.67513319 0.0724645104,3.85772958 C-0.181425154,3.07787353 0.253136713,2.2424867 1.04308561,1.99184088 C1.06050953,1.98631238 1.07803432,1.98109865 1.09565122,1.97620231 Z' id='Rectangle-Copy-11' fill='#ED3163'></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export {
    LogoMobileIcon,
    Line1Icon,
    LogoLoader,
    Line1DesktopIcon,
    Line2DesktopIcon,
    Line3DesktopIcon,
    Line2Icon,
    Line3Icon,
    PlayVideoIcon,
    ArrowDownIcon,
    VenueManagement1Icon,
    VenueManagement2Icon,
    VenueManagement3Icon,
    VenueManagement4Icon,
    VenueManagement5Icon,
    VenueManagement6Icon,
    VenueManagement7Icon,
    VenueManagement8Icon,
    VenueManagement9Icon,
    VenueManagement10Icon,
    VenueManagement11Icon,
    VenueManagement12Icon,
    Benefits1Icon,
    Benefits2Icon,
    Benefits3Icon,
    Benefits4Icon,
    ChampionIcon,
    InCallIcon,
    OutCallIcon,
    LogoIcon,
    LocationsIcon,
    PhoneIcon,
    EmailIcon,
    CloseIcon,
    UploadIcon,
    PlusIcon,
    TriangleIcon,
}
